var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50079 1.83847C6.62387 1.70638 6.69088 1.53167 6.6877 1.35116C6.68451 1.17064 6.61138 0.998413 6.48372 0.87075C6.35606 0.743086 6.18382 0.66996 6.00331 0.666775C5.8228 0.66359 5.64809 0.730595 5.516 0.853675L0.87077 5.49891C0.740285 5.62956 0.666992 5.80666 0.666992 5.9913C0.666992 6.17595 0.740285 6.35305 0.87077 6.4837L5.516 11.1289C5.58034 11.1941 5.65703 11.2457 5.74158 11.2808C5.82614 11.3159 5.91685 11.3338 6.0084 11.3333C6.09995 11.3338 6.19066 11.3159 6.27522 11.2808C6.35977 11.2457 6.43646 11.1941 6.50079 11.1289C6.63128 10.9983 6.70457 10.8212 6.70457 10.6365C6.70457 10.4519 6.63128 10.2748 6.50079 10.1441L2.34795 5.9913L6.50079 1.83847ZM6.00512 10.6398L6.0084 11.3333L6.0117 10.6332L6.00512 10.6398ZM6.00512 10.6398L6.0117 10.6332L6.01312 10.3334C6.01155 10.3334 6.00997 10.3334 6.0084 10.3333C6.00682 10.3334 6.00525 10.3334 6.00368 10.3334L6.00512 10.6398Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateBackIcon);
export default __webpack_public_path__ + "static/media/navigate-back_icon.5f6654a5b57b72c9fd2092f8044789e7.svg";
export { ForwardRef as ReactComponent };